import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import IBuffered from "../../../Vuex/IBuffered";

@Component
export default class Item<T> extends Vue {
	protected defaults: T = undefined as any;

	@Prop({ required: true }) protected from!: IBuffered<T> & { from: string | number };

	get item(): T {
		if (!this.isReady) {
			if (this.defaults === undefined) {
				throw new Error("No defaults have been set in created()");
			}
			return this.defaults;
		} else {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			return this.from.value!;
		}
	}

	get isReady(): boolean {
		return !!this.from?.value;
	}

	// The containing list injects this reset method which discards
	// all the entries of the lists and reloads them from the server.
	// Note that this does not reset the conversion from raw
	// data (say a BE's Id) to displayed item (member name, displayed URLs, …)
	// This function returns a promise that resolves once the new items have been loaded.
	@Inject() protected reset!: (until?: Promise<unknown>) => Promise<unknown>;
}
